import styled from 'styled-components';
import { ProgressDots } from '@spotify-internal/encore-web';

const LoadingIndicatorContainer = styled.div<{ isSmallHeight?: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  height: ${props => (props.isSmallHeight ? '10vh' : '45vh')};
`;

type IndicatorSizes = 'sm' | 'md' | 'lg';

const sizeMap: Record<IndicatorSizes, 'small' | 'medium' | 'large'> = {
  sm: 'small',
  md: 'medium',
  lg: 'large',
};

interface LoadingProps {
  size?: IndicatorSizes;
  smallHeight?: boolean;
  className?: string;
}

export const Loading = ({
  size = 'lg',
  smallHeight = false,
  ...props
}: LoadingProps) => {
  return (
    <LoadingIndicatorContainer isSmallHeight={smallHeight} {...props}>
      <ProgressDots size={sizeMap[size]} />
    </LoadingIndicatorContainer>
  );
};
